import React from "react";

const SvgViewDark = props => {
  let color = '#091E42';
  if (props.color) {
    color = color;
  }
  if (props.selected) {
    color = 'white'
  }
  return (<svg width={24} height={24} {...props}>
    <defs>
      <path
        id="view-dark_svg__a"
        d="M18.656 11.355c-.254-.62-.537-1.166-.828-1.575-.579-.814-1.274-1.447-2.08-1.9-1.023-.579-2.274-.88-3.743-.88-1.464 0-2.72.302-3.755.883A6.41 6.41 0 0 0 6.171 9.78c-.29.407-.573.953-.827 1.573a12.74 12.74 0 0 0-.245.649c.272.792.646 1.62 1.073 2.217.579.813 1.274 1.446 2.076 1.896 1.037.583 2.29.886 3.75.886 1.458 0 2.713-.303 3.746-.884a6.46 6.46 0 0 0 2.094-1.913c.421-.59.79-1.407 1.063-2.2a13.057 13.057 0 0 0-.245-.648zM21 12c-.136.466-.663 2.146-1.535 3.366a8.453 8.453 0 01-2.737 2.491c-1.347.758-2.94 1.143-4.73 1.143-1.793 0-3.383-.385-4.73-1.143-1.064-.596-1.98-1.431-2.725-2.48-.878-1.226-1.407-2.911-1.543-3.38.136-.465.665-2.148 1.543-3.38A8.41 8.41 0 0 1 7.27 6.14C8.62 5.383 10.212 5 12.005 5c1.8 0 3.39.383 4.727 1.14a8.344 8.344 0 0 1 2.725 2.48C20.335 9.851 20.864 11.534 21 12zm-6 0c0-.8-.312-1.553-.88-2.12A2.98 2.98 0 0 0 12 9c-.8 0-1.553.312-2.12.88A2.98 2.98 0 0 0 9 12c0 .8.312 1.553.88 2.12A2.98 2.98 0 0 0 12 15c.8 0 1.553-.312 2.12-.88A2.98 2.98 0 0 0 15 12z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="view-dark_svg__b" fill="#fff">
        <use xlinkHref="#view-dark_svg__a" />
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#view-dark_svg__a" />
      <g fill={color} mask="url(#view-dark_svg__b)">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>)
};

export default SvgViewDark;